import { render, staticRenderFns } from "./CustomerAddresses.vue?vue&type=template&id=291035d3&"
import script from "./CustomerAddresses.vue?vue&type=script&lang=js&"
export * from "./CustomerAddresses.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports